/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useEffect } from "react";
import { Button } from "react-bootstrap";
import { addErrorClasses } from "components/template-component/form-error-label/ErrorLabel";
import { Formik } from "formik";
import Textbox from "components/wrapped-component/hint-controls/Textbox";
import Label from "components/wrapped-component/hint-controls/Label";
import * as Yup from "yup";
// eslint-disable-next-line import/no-cycle
import { useLocation, useHistory } from "react-router-dom";
import { IUserDetails } from "interfaces";
import GeneralUtils from "GeneralUtils";
import userDataUtil from "services/user-data-util";
import { toast } from "react-toastify";
import { httpIAM } from "../../services/http.IAM";
import login from "../../assets/images/login.jpg";
import runtimeEnv from "../../runtime-env";

const formValidationSchema = Yup.object({
  UserName: Yup.string().required("Required").max(40),
  Password: Yup.string().required("Required").max(100)
});

const Login = (props: any) => {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const error = params.get("error");

    if (error === "sso_failed") {
      toast.error("SSO login failed. Please sign in manually.", {
        autoClose: false
      });

      history.replace("/login");
    }
  }, [location.search, history]);

  return (
    <Formik
      enableReinitialize
      initialValues={{
        UserName: "",
        Password: ""
      }}
      validationSchema={formValidationSchema}
      onSubmit={(values: any) => {
        httpIAM
          .login(values.UserName, values.Password)
          .then((authToken: any) => {
            if (!authToken) {
              return;
            }
            GeneralUtils.appendCookie("INIT_USER_STATS", "");
            GeneralUtils.appendCookie("AUTH_TOKEN", authToken);
            return httpIAM
              .getUserDetails(values.UserName)
              .then((user: IUserDetails) => {
                GeneralUtils.appendCookie("USER_DETAILS", JSON.stringify(user));
                const previousDatabase =
                  GeneralUtils.getCookieValue("DATABASE");
                if (
                  user?.databases?.length > 0 &&
                  (!previousDatabase ||
                    !user.databases.find((x) => x.id === previousDatabase))
                ) {
                  GeneralUtils.appendCookie("DATABASE", user.databases[0].id);
                }
                userDataUtil.initializeUserStats();
                GeneralUtils.clearGlobalVars();
                history.replace("/");
              });
          })
          .catch(() => {});
      }}
    >
      {({ handleSubmit, handleChange, values, errors, touched }) => (
        <form
          onSubmit={handleSubmit}
          onChange={handleChange}
          className="custom-form login-align-center"
        >
          <div
            className="w-100 height-100vh"
            style={{
              backgroundImage: `url(${login})`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center"
            }}
          >
            <div className="position-absolute w-100">
              <div className="m-auto mt50 w500 background-color-light p30 rounded shadow-lg">
                <h3 className="mb30 text-center">Login to your account</h3>
                <Label
                  labelTitle="User Name"
                  labelPosition="top"
                  labelSize="10"
                  fieldSize="30"
                  errorSize="20"
                  error={errors.UserName}
                  isFieldTouched={touched.Password}
                  required
                  className="mb10"
                >
                  <Textbox
                    value={values.UserName}
                    autoComplete="off"
                    name="UserName"
                    placeholder="User Name"
                    className={`${addErrorClasses(
                      errors.UserName,
                      touched.UserName
                    )} border`}
                  />
                </Label>
                <Label
                  labelTitle="Password"
                  labelPosition="top"
                  labelSize="10"
                  fieldSize="30"
                  errorSize="20"
                  error={errors.Password}
                  isFieldTouched={touched.Password}
                  required
                >
                  <Textbox
                    type="password"
                    value={values.Password}
                    autoComplete="off"
                    name="Password"
                    placeholder="Password"
                    className={`${addErrorClasses(
                      errors.Password,
                      touched.Password
                    )} border`}
                  />
                </Label>
                <Button
                  block
                  type="submit"
                  variant="primary"
                  size="lg"
                  className="mr10 mb20 mt20"
                >
                  Login
                </Button>
                <div className="text-center">
                  Unable to Login?
                  <a
                    href="https://www.google.com"
                    target="blank"
                    className="ml4"
                  >
                    Contact Us
                  </a>
                </div>
                <div className="text-center mt10">
                  <span className="text-muted small">
                    {runtimeEnv.ENV}
                    {runtimeEnv.BUILD_VERSION &&
                      `: ${runtimeEnv.BUILD_VERSION}`}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
};

export default Login;
